import React from 'react';
// styles
import './Conditions.css';

interface Props {
  className?: string;
}

class Conditions extends React.Component<Props> {

  render(): JSX.Element {
    return (
      <div className="referal-conditions">
        <div className="container">
        <div className="referal-conditions-inner">
          <h1 className="referal-conditions-title bold">
            За рекомендованного друга вы можете<br/>
            получить бонус до 100 тысяч рублей
          </h1>
          <div className="main-conditions-list">
            <h3 className="bold">Что нужно делать?</h3>
            <ul>
              <li>Ознакомиться со списком открытых вакансий на этой странице.</li>
              <li>Рассказать о нашей компании и вакансии другу.</li>
              <li>Заполнить заявку на этой странице</li>
              <li>Получить фидбэк от HR по итогам рассмотрения.</li>
            </ul>
          </div>
          <div className="success-conditions-list">
            <h3 className="bold">При каких условиях выплачивается бонус?</h3>
            <ul>
              <li>Размер денежного вознаграждения составляет 100 тысяч рублей.</li>
              <li>50% от суммы бонуса выплачивается по факту выхода рекомендуемого сотрудника, </li>
              <li>оставшиеся 50% - по итогам прохождения испытательного срока.</li>
            </ul>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default Conditions;
